import { compose, propEq, find } from 'ramda'

export const getUpgradePopupPlayerMessage = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_PLAYER_HD_MSG'))
)
